/**
 * Décide s’il faut enchaîner un lot suivant pour remplir un grand viewport
 * (2K…) sans exiger un geste de scroll.
 */
export function shouldFillViewportWithNextPage(opts: {
  loading: boolean;
  hasMore: boolean;
  sentinelInViewport: boolean;
}): boolean {
  return !opts.loading && opts.hasMore && opts.sentinelInViewport;
}
